/**
 * TokenInvalid - Seite für ungültige/abgelaufene Tokens
 */

import React from 'react';
import {
  Box,
  Paper,
  Typography
} from '@mui/material';
import {
  Error as ErrorIcon,
  Schedule as ExpiredIcon,
  CheckCircle as SubmittedIcon
} from '@mui/icons-material';

const TokenInvalid = ({ reason, message }) => {
  const getContent = () => {
    switch (reason) {
      case 'expired':
        return {
          icon: <ExpiredIcon sx={{ fontSize: 80, color: '#ff9800' }} />,
          title: 'Link abgelaufen',
          color: '#ff9800'
        };
      case 'submitted':
        return {
          icon: <SubmittedIcon sx={{ fontSize: 80, color: '#4caf50' }} />,
          title: 'Bereits ausgefüllt',
          color: '#4caf50'
        };
      default:
        return {
          icon: <ErrorIcon sx={{ fontSize: 80, color: '#f44336' }} />,
          title: 'Ungültiger Link',
          color: '#f44336'
        };
    }
  };

  const content = getContent();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: { xs: 2, sm: 3 },
        background: 'linear-gradient(135deg, #1a6ead 0%, #004c80 100%)'
      }}
    >
      <Paper
        elevation={3}
        sx={{
          maxWidth: { xs: '100%', sm: 500 },
          width: '100%',
          p: { xs: 3, sm: 4 },
          textAlign: 'center',
          borderRadius: { xs: 2, sm: 3 }
        }}
      >
        {content.icon}

        <Typography variant="h4" sx={{ mt: 2, mb: 1, color: content.color }}>
          {content.title}
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {message}
        </Typography>

        {reason === 'expired' && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Bitte kontaktieren Sie die Praxis, um einen neuen Link anzufordern.
          </Typography>
        )}

        {reason === 'submitted' && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Vielen Dank! Ihre Anamnese wurde bereits an die Praxis übermittelt.
          </Typography>
        )}

        <Box sx={{ mt: 3 }}>
          <Typography variant="body2" color="text.secondary">
            Zahnarztpraxis Dr. Hezel
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Telefon: (0391) 123 456
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default TokenInvalid;
